import { useTranslations } from 'next-intl'

import { cn } from '@/shared/lib'
import { Notice } from '@/shared/ui'

export type Props = {
  className?: string
  titleClassName?: string
  listClassName?: string
  isOldRefundTerms: boolean
}

export const RefundTermNotice = ({
  isOldRefundTerms,
  className,
  titleClassName,
  listClassName,
}: Props) => {
  const t = useTranslations('refund_policy')

  return (
    <div className={cn('px-6', className)}>
      <Notice.Title hasIcon={false} className={titleClassName}>
        {t('notice.title')}
      </Notice.Title>
      <Notice.List gap={false} className={listClassName}>
        <Notice.Item>
          {t('notice.item.payment_day_cancellation', {
            isOldRefundTerms: isOldRefundTerms.toString(),
          })}
        </Notice.Item>
        <Notice.Item>{t('notice.item.refund_excludes_fees')}</Notice.Item>
        <Notice.Item>{t('notice.item.policy_by_landlord')}</Notice.Item>
        <Notice.Item>{t('notice.item.landlord_cancellation')}</Notice.Item>
      </Notice.List>
    </div>
  )
}
